import { setPopulation } from '../map';
import getPopulation from '../../lib/mapService/getPopulation';

const limit = (altitude) => {
  if (altitude < 0.0) {
    return 0.0;
  }

  return altitude;
};

/**
 * Set population.
 * @param {!object} coordinate A coordinate.
 * @param {!number} radius Radius of the population search from coordinate.
 * @return {function} action dispatcher.
 */
export default (coordinate, radius) => async (dispatch, getState) => {
  const { altitudes } = getState();
  let population = -1;

  try {
    population = await getPopulation(
        coordinate,
        radius,
        limit(altitudes.value),
    );
  } catch (e) {
    return;
  }

  if (population < 0) {
    return;
  }

  dispatch(setPopulation(population));
};
